import { FETCH_TRANSPORTER_SHARE_TRACK, RECEIVE_TRANSPORTER_SHARE_TRACK, FAILED_TRANSPORTER_SHARE_TRACK } from '../actions/aTransporter-ShareTracker'

const defaultTransporterShareTrackState = {
    transporterShareTrackData: [],
    success: true,
    fail: false,
    driverVac: 0,
    asstVac: 0,
    closed: false
}

export function fetchTransporterShareTrack(state = defaultTransporterShareTrackState, action){
    let _close
    let _success
    switch (action.type) {
        case FETCH_TRANSPORTER_SHARE_TRACK:
            return ({transporterShareTrackData: [], success: true, closed: false, inProgress: true, fail: false, driverVac: 0, asstVac: 0})
        case RECEIVE_TRANSPORTER_SHARE_TRACK:
            if(action.payload.result === []) {
                _close = true
            } else {
                _close = false
            }
            // console.log(action.payload[0].assist_vac_details.length)
            return Object.assign({}, state, {transporterShareTrackData: action.payload, closed: _close, driverVac: action.payload[0].driver_vac_detail.length, asstVac: action.payload[0].assist_vac_detail.length, success: true, inProgress: false, fail: false})
        case FAILED_TRANSPORTER_SHARE_TRACK:
            if(!action.payload) {
                _close = true
                _success = true
            } else {
                _close = false
                _success = false
            }
            return ({transporterShareTrackData: [], success: _success, inProgress: false, closed: _close, fail: true, driverVac: 0, asstVac: 0})
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/redTransporter-ShareTracker.jsx